import React from "react";
import "./product.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Atalantaimages from "./Atalanta.js";
import Athenaimages from "./Athena.js";
import Frejaimages from "./Freja.js";
import Heraimages from "./Hera.js";
import Madisonimages from "./Madison.js";
import Dephneimages from "./Dephne.js";
import Palmaimages from "./Palma.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsUpDownLeftRight } from "@fortawesome/free-solid-svg-icons";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import { faBed } from "@fortawesome/free-solid-svg-icons";
import { faShower } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import Mapleimages from "./maple.js";
import ivyimage from "../../media/ivy/ivy.js";
import stoneimage from "./StonegateparkEmeraldstone.js";
import nwg from "../../media/nwg/nwg.js";

const product = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const importAll = (r) => {
    return r.keys().map(r);
  };

  const oliveImages = importAll(
    require.context("../../media/Olive", false, /\.(png|jpe?g|svg)$/),
  );
  const hazelImages = importAll(
    require.context("../../media/Hazel", false, /\.(png|jpe?g|svg)$/),
  );

  const athenawa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=+6282297791381&text=Halo%20Vania,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Rumah%20(Athena)%20https://marketing-citralandsurabaya.com/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const herawa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=+6282297791381&text=Halo%20Vania,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Rumah%20(hera)%20https://marketing-citralandsurabaya.com/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const atalantawa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=+6282297791381&text=Halo%20Vania,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Rumah%20(atalanta)%20https://marketing-citralandsurabaya.com/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const frejawa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=+6282297791381&text=Halo%20Vania,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Rumah%20(atalanta)%20https://marketing-citralandsurabaya.com/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const madisonwa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=+6282297791381&text=Halo%20Vania,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Rumah%20(atalanta)%20https://marketing-citralandsurabaya.com/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const dephnewa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=+6282297791381&text=Halo%20Vania,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Rumah%20(daphne)%20https://marketing-citralandsurabaya.com/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const olivewa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=+6282297791381&text=Halo%20Vania,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Rumah%20(olive)%20https://marketing-citralandsurabaya.com/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const hazelwa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=+6282297791381&text=Halo%20Vania,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Rumah%20(hazel)%20https://marketing-citralandsurabaya.com/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const maplewa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=+6282297791381&text=Halo%20Vania,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Rumah%20(maple)%20https://marketing-citralandsurabaya.com/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const stonewa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=+6282297791381&text=Halo%20Vania,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Rumah%20(stonegatepark+emeraldstone)%20https://marketing-citralandsurabaya.com/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const ivywa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=+6282297791381&text=Halo%20Vania,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Rumah%20(ivy)%20https://marketing-citralandsurabaya.com/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const ardenwa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=+6282297791381&text=Halo%20Vania,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Rumah%20(arden+palma+grandia)%20https://marketing-citralandsurabaya.com/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const nwgwa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=+6282297791381&text=Halo%20Vania,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Rumah%20(Northwest+Garden)%20https://marketing-citralandsurabaya.com/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  return (
    <div className="container11">
      <div className="judul-newlaunch">
        <div id="product" className="judul21">
          OUR HOME{" "}
        </div>
      </div>
      <div className="container-card1">
        <div className="kartu">
          <Slider {...settings}>
            {Dephneimages.map((image, index) => (
              <div>
                <img
                  className="kartugambarf"
                  key={index}
                  src={image}
                  alt="madison"
                />
              </div>
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Northwest Hill</div>
              <span>Daphne</span>
              <span>FREE PPN</span>
            </div>
            <div className="cicilan">
              <div className="angka">3</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon icon={faArrowsUpDownLeftRight} />
            <span> : 60m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 44m²</span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 2</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 1</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={dephnewa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
        <div className="kartu">
          <Slider {...settings}>
            {nwg.map((image, index) => (
              <div>
                <img
                  className="kartugambarf"
                  key={index}
                  src={image}
                  alt="madison"
                />
              </div>
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Northwest Garden</div>
              <span>Free DP</span>
            </div>
            <div className="cicilan">
              <div className="angka">4</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon icon={faArrowsUpDownLeftRight} />
            <span> : 40m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 59m²</span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 2</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 2</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={nwgwa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
        <div className="kartu">
          <Slider {...settings}>
            {ivyimage.map((image, index) => (
              <div>
                <img
                  className="kartugambar1"
                  key={index}
                  src={image}
                  alt="athena"
                />
              </div>
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Northwest Hill</div>
              <span>Ivy Deluxe</span>
            </div>
            <div className="cicilan">
              <div className="angka">4</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon icon={faArrowsUpDownLeftRight} />
            <span> : 60m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 44m²</span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 2</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 1</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={ivywa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
      </div>
      <div className="container-card2">
        <div className="kartu">
          <Slider {...settings}>
            {Athenaimages.map((image, index) => (
              <div>
                <img
                  className="kartugambar1"
                  key={index}
                  src={image}
                  alt="athena"
                />
              </div>
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Northwest Park</div>
              <span>Athena</span>
            </div>
            <div className="cicilan">
              <div className="angka">5</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon icon={faArrowsUpDownLeftRight} />
            <span> : 50m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 68m²</span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 3</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 2</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={athenawa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
        <div className="kartu">
          <Slider {...settings}>
            {Frejaimages.map((image, index) => (
              <div>
                <img
                  className="kartugambarf"
                  key={index}
                  src={image}
                  alt="freja"
                />
              </div>
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Northwest Central</div>
              <span>Freja </span>
              <span>FREE PPN</span>
            </div>
            <div className="cicilan">
              <div className="angka">6</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon icon={faArrowsUpDownLeftRight} />
            <span> : 60m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 110m²</span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 3</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 3</span>
          </div>
          <div className="containerwhatsapp12">
            <button onClick={frejawa} className="whatsapp12">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
        <div className="kartu">
          <Slider {...settings}>
            {Atalantaimages.map((image, index) => (
              <div>
                <img
                  className="kartugambar1"
                  key={index}
                  src={image}
                  alt="atalanta"
                />
              </div>
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Northwest Park</div>
              <span>Atalanta</span>
            </div>
            <div className="cicilan">
              <div className="angka">8</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon icon={faArrowsUpDownLeftRight} />
            <span> : 72m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 103m²</span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 4</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 3</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={atalantawa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
      </div>
      <div className="container-card2">
        <div className="kartu">
          <Slider {...settings}>
            {Heraimages.map((image, index) => (
              <div>
                <img
                  className="kartugambarf"
                  key={index}
                  src={image}
                  alt="hera"
                />
              </div>
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Northwest Central</div>
              <span>Hera</span>
            </div>
            <div className="cicilan">
              <div className="angka">8</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon icon={faArrowsUpDownLeftRight} />
            <span> : 72m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 137m²</span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 4</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 3</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={herawa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
        <div className="kartu">
          <Slider {...settings}>
            {oliveImages.map((image, index) => (
              <img
                className="kartugambar"
                key={index}
                src={image}
                alt={`Astha ${index + 1}`}
              />
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Olive</div>
              <span>Dempsey Hill</span>
            </div>
            <div className="cicilan">
              <div className="angka">10</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon icon={faArrowsUpDownLeftRight} />
            <span> : 105m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 149m²</span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 3</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 3</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={olivewa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
        <div className="kartu">
          <Slider {...settings}>
            {Palmaimages.map((image, index) => (
              <div>
                <img
                  className="kartugambarf"
                  key={index}
                  src={image}
                  alt="palmagrandia"
                />
              </div>
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Arden</div>
              <span>Palma Grandia</span>
            </div>
            <div className="cicilan">
              <div className="angka">12</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon icon={faArrowsUpDownLeftRight} />
            <span> : 150m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 192m²</span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 4+1</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 4+1</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={ardenwa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
      </div>
      <div className="container-card2">
        <div className="kartu">
          <Slider {...settings}>
            {hazelImages.map((image, index) => (
              <img
                className="kartugambar"
                key={index}
                src={image}
                alt={`Astha ${index + 1}`}
              />
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Hazel</div>
              <span>Dempsey Hill</span>
            </div>
            <div className="cicilan">
              <div className="angka">14</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon icon={faArrowsUpDownLeftRight} />
            <span> : 135m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 191m²</span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 3+1</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 3+1</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={hazelwa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
        <div className="kartu">
          <Slider {...settings}>
            {Madisonimages.map((image, index) => (
              <div>
                <img
                  className="kartugambarf"
                  key={index}
                  src={image}
                  alt="madison"
                />
              </div>
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Pelican Hill</div>
              <span>Madison</span>
            </div>
            <div className="cicilan">
              <div className="angka">18</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon icon={faArrowsUpDownLeftRight} />
            <span> : 200m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 226m²</span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 5</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 4</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={madisonwa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
        <div className="kartu">
          <Slider {...settings}>
            {Mapleimages.map((image, index) => (
              <div>
                <img
                  className="kartugambar1"
                  key={index}
                  src={image}
                  alt="maple"
                />
              </div>
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Maple</div>
              <span>Dempsey Hill</span>
            </div>
            <div className="cicilan">
              <div className="angka">19</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon icon={faArrowsUpDownLeftRight} />
            <span> : 170m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 255m²</span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 4+1</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 3+1</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={maplewa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
      </div>
      <div className="container-card2">
        <div className="kartu">
          <Slider {...settings}>
            {stoneimage.map((image, index) => (
              <div>
                <img
                  className="kartugambar1"
                  key={index}
                  src={image}
                  alt="maple"
                />
              </div>
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Stone Gate Park & Emerald Stone</div>
            </div>
            <div className="cicilan">
              <div className="angka">13</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon icon={faArrowsUpDownLeftRight} />
            <span> : 105m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 149m²</span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 4</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 3</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={stonewa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default product;
